import {createHookDefinition} from '../../utils/hooksUtils'

interface AfterRender {}

export const RENDER_HOOKS = {
    AFTER_RENDER: createHookDefinition<'after_render', AfterRender>('after_render')
}
